// extracted by mini-css-extract-plugin
module.exports = {"reportsContainer":"reportsCSS_reportsContainer__2_TCE","reportLabelContainer":"reportsCSS_reportLabelContainer__33mf9","reportBody":"reportsCSS_reportBody__3rLI0"};